import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthRedirect = ({ children, isAuthenticated }) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      // Если пользователь уже авторизован, перенаправляем его на главную страницу
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  // Если пользователь авторизован, не рендерим детей (они все равно скоро будут заменены)
  if (isAuthenticated) {
    return null;
  }

  // Если пользователь не авторизован, рендерим детей (форму входа/регистрации)
  return children;
};

export default AuthRedirect; 